"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _cookieNotification = _interopRequireDefault(require("./cookie-notification"));

var _buttonHelpers = require("../contentful-views/util/button-helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Contentful Widget to map CookieNotification to it's custom component.
 */
var CookieNotificationWidget = function CookieNotificationWidget(_ref) {
  var model = _ref.model;

  var _buttonModel = (0, _buttonHelpers.buttonModel)(_lodash["default"].get(model, 'fields.acceptNotificationCta')),
      ctaProps = _buttonModel.props,
      ctaText = _buttonModel.text;

  var text = _react["default"].createElement(_markdown["default"], {
    source: _lodash["default"].get(model, 'fields.cookieNotificationText')
  });

  var hidden = _lodash["default"].get(model, 'fields.hidden');

  return _react["default"].createElement(_cookieNotification["default"], {
    ctaProps: ctaProps,
    ctaText: ctaText,
    hidden: hidden,
    text: text
  });
};

CookieNotificationWidget.propTypes = {
  model: _propTypes["default"].shape({
    fields: _propTypes["default"].shape({
      acceptNotificationCta: _propTypes["default"].shape({
        ctaProps: _propTypes["default"].shape({}),
        text: _propTypes["default"].string
      }),
      cookieNotificationText: _propTypes["default"].string,
      hidden: _propTypes["default"].bool
    })
  })
};
CookieNotificationWidget.defaultProps = {
  model: {}
};
var _default = CookieNotificationWidget;
exports["default"] = _default;